function showToast(message, type) {
	let toastContainer = document.getElementById('toast-container');
	const toast = document.createElement('div');
	toast.className = 'toast';
	toast.textContent = message;
	if (type === 'success') {
		toast.style.backgroundColor = '#2ecc71';
	} else if (type === 'error') {
		toast.style.backgroundColor = '#e74c3c';
	}

	toast.style.opacity= '0';
	toastContainer.appendChild(toast);

	setTimeout(() => {
		toast.style.opacity = '1';
		toastContainer.style.opacity = '1';
	}, 1000);

	setTimeout(() => {
	    toast.style.opacity = '0';
	    setTimeout(() => {
	        toastContainer.removeChild(toast);
	    }, 300);
	}, 4000);
}